import React, { createContext, useContext, useMemo, useState } from 'react';

type DurationSplitBarHoveredEntryContextValue = {
  hoveredEntryId: string | null;
  setHoveredEntryId: (hoveredEntry: string | null) => void;
};

export const DurationSplitBarHoveredEntryContext = createContext<
  DurationSplitBarHoveredEntryContextValue | undefined
>(undefined);

export const useDurationSplitBarHoveredEntryContext = (): DurationSplitBarHoveredEntryContextValue => {
  const value = useContext(DurationSplitBarHoveredEntryContext);
  if (!value) {
    throw Error(
      'should be called in DurationSplitBarHoveredEntryContextProvider scope'
    );
  }
  return value;
};

type DurationSplitBarHoveredEntryContextProviderProps = {
  children?: React.ReactNode;
};
export const DurationSplitBarHoveredEntryContextProvider: React.FC<DurationSplitBarHoveredEntryContextProviderProps> = ({
  children
}: DurationSplitBarHoveredEntryContextProviderProps) => {
  const [hoveredEntryId, setHoveredEntryId] = useState<string | null>(null);
  const value = useMemo(
    () => ({
      hoveredEntryId,
      setHoveredEntryId
    }),
    [hoveredEntryId]
  );

  return (
    <DurationSplitBarHoveredEntryContext.Provider value={value}>
      {children}
    </DurationSplitBarHoveredEntryContext.Provider>
  );
};
